"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var React = __importStar(require("react"));

exports.VolumeOffIcon = function () {
  return React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("g", null, React.createElement("polygon", {
    points: "15.712,5.85 15.005,5.143 12.859,7.29 10.712,5.143 10.005,5.85 12.152,7.997 10.005,10.143 10.712,10.85 12.859,8.704 15.005,10.85 15.712,10.143 13.566,7.997 \t"
  }), React.createElement("path", {
    d: "M1.788,5.569c-0.827,0-1.5,0.673-1.5,1.5v2.062c0,0.827,0.673,1.5,1.5,1.5h1.091l4.406,3.812V1.557L2.871,5.569H1.788z"
  })));
};

exports.VolumeHighIcon = function () {
  return React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M11.126,1.502v1c0.903,0,3.746,1.706,3.746,5.671c0,4.053-2.92,5.329-3.746,5.329v1c1.396,0,4.746-1.821,4.746-6.329 C15.872,3.487,12.477,1.502,11.126,1.502z"
  }), React.createElement("path", {
    d: "M12.661,8.14c0-2.743-2.301-4.179-3.535-4.179v1c0.516,0,2.535,0.83,2.535,3.179c0,2.307-1.999,3.076-2.535,3.076v1 C10.167,12.216,12.661,11.043,12.661,8.14z"
  }), React.createElement("path", {
    d: "M1.628,5.509c-0.827,0-1.5,0.673-1.5,1.5v2.062c0,0.827,0.673,1.5,1.5,1.5h1.09l4.406,3.812V1.498L2.711,5.509H1.628z"
  })));
};

exports.VolumeLowIcon = function () {
  return React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M10.731,4.021v1c0.516,0,2.535,0.83,2.535,3.179c0,2.307-1.999,3.076-2.535,3.076v1c1.041,0,3.535-1.173,3.535-4.076 C14.267,5.457,11.965,4.021,10.731,4.021z"
  }), React.createElement("path", {
    d: "M3.233,5.57c-0.827,0-1.5,0.673-1.5,1.5v2.062c0,0.827,0.673,1.5,1.5,1.5h1.09l4.406,3.812V1.556L4.316,5.57H3.233z"
  })));
};

exports.VolumeVeryLowIcon = function () {
  return React.createElement("svg", {
    viewBox: "0 0 16 16"
  }, React.createElement("path", {
    d: "M7.085,5.569H6.002c-0.827,0-1.5,0.673-1.5,1.5v2.062c0,0.827,0.673,1.5,1.5,1.5h1.091l4.406,3.812V1.557 L7.085,5.569z"
  }));
};

var VolumeIcon = function VolumeIcon(_a) {
  var muted = _a.muted,
      volume = _a.volume;

  if (muted) {
    return React.createElement(exports.VolumeOffIcon, null);
  }

  if (volume > 0.5) {
    return React.createElement(exports.VolumeHighIcon, null);
  }

  if (volume > 0.25) {
    return React.createElement(exports.VolumeLowIcon, null);
  }

  return React.createElement(exports.VolumeVeryLowIcon, null);
};

exports["default"] = VolumeIcon;